
import './App.css';
import NavbarComp from './components/NavbarComp';
import Home from './components/Home'
function App() {
  return (
    <div>
      <NavbarComp />
      <Home />
    </div>
  );
}

export default App;
